import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api, resolveImg, fmtRON } from "@/lib/api";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { Skeleton } from "@/components/ui/skeleton";
import { Badge } from "@/components/ui/badge";
import { Luggage } from "lucide-react";

export default function Trips() {
  const [trips, setTrips] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/my/trips").then(({ data }) => setTrips(data)).finally(() => setLoading(false));
  }, []);

  const statusMap = {
    confirmed: { label: "Confirmată", cls: "bg-primary text-primary-foreground" },
    pending: { label: "În așteptare", cls: "bg-muted text-foreground" },
    cancelled: { label: "Anulată", cls: "bg-destructive text-destructive-foreground" },
  };

  return (
    <div className="App">
      <Navbar />
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-10">
        <h1 className="font-heading text-4xl font-semibold tracking-tight">Călătoriile mele</h1>
        <p className="text-muted-foreground mt-1">Rezervările tale la cabane și chalete din Carpați</p>

        {loading ? (
          <div className="space-y-4 mt-8">{Array.from({ length: 3 }).map((_, i) => <Skeleton key={i} className="h-32 rounded-2xl" />)}</div>
        ) : trips.length === 0 ? (
          <div className="text-center py-24">
            <Luggage className="h-12 w-12 text-muted-foreground mx-auto mb-4" />
            <p className="text-lg text-muted-foreground">Încă nu ai nicio rezervare.</p>
            <Link to="/" className="text-accent font-medium hover:underline mt-2 inline-block">Explorează cazările</Link>
          </div>
        ) : (
          <div className="space-y-4 mt-8">
            {trips.map((t) => {
              const s = statusMap[t.status] || statusMap.pending;
              return (
                <Link to={`/proprietate/${t.property_id}`} key={t.id} data-testid={`trip-${t.id}`}
                      className="card-hover flex gap-4 rounded-2xl border border-border/60 bg-card overflow-hidden">
                  <img src={resolveImg(t.property_image)} alt="" className="w-40 h-32 object-cover shrink-0" />
                  <div className="py-4 pr-4 flex-1">
                    <div className="flex items-start justify-between gap-2">
                      <h3 className="font-medium text-lg leading-snug">{t.property_title}</h3>
                      <Badge className={`${s.cls} shrink-0`}>{s.label}</Badge>
                    </div>
                    <p className="text-sm text-muted-foreground mt-1 font-mono">{t.check_in} → {t.check_out} · {t.nights} nopți · {t.guests} oaspeți</p>
                    <p className="text-sm font-semibold mt-2">{fmtRON(t.total_amount)}</p>
                  </div>
                </Link>
              );
            })}
          </div>
        )}
      </div>
      <Footer />
    </div>
  );
}
